(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('cartItems', () => ({
      loading: false,

      update(productId, quantity) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: productId,
            quantity: +quantity,
          }),
        })
          .then(() => {
            Alpine.store('cart_drawer').update(false);
            this.renderItems();
          })
          .catch((error) => {
            Alpine.store('notification').notify({
              type: 'error',
              title: 'Error',
              message: 'Failed to add product to cart',
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },

      remove(lineItemId) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            quantity: 0,
            line: lineItemId,
          }),
        })
          .then(() => {
            Alpine.store('cart_drawer').update(false);
            this.renderItems();
          })
          .catch((error) => {
            Alpine.store('notification').notify({
              type: 'error',
              title: 'Error',
              message: 'Failed to add product to cart',
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },

      renderItems(url) {
        this.loading = true;
        fetch('/cart', { method: 'GET' })
          .then((res) => res.text())
          .then((html) => {
            let doc = new DOMParser().parseFromString(html, 'text/html');

            if (doc.querySelector('#cart_items_container')) {
              this.updateDOM('#cart_items_container', doc);
              this.updateDOM('#estimated_total', doc);
            } else {
              this.updateDOM('#main_cart_items', doc);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },

      updateDOM(selector, doc) {
        let newContent = doc.querySelector(selector);
        if (newContent) document.querySelector(selector).innerHTML = newContent.innerHTML;
      },

      onQuantityChange(event, delta = null) {
        event.preventDefault();
        let el;

        if (delta !== null) {
          let container = event.target.closest('button').parentElement;
          el = container.querySelector('input[type="number"]');
          el.value = +el.value + delta;
        } else {
          el = event.target;
        }

        let productId = el.dataset.productId;
        let newQuantity = +el.value;
        let maxQuantity = +el.getAttribute('max');

        if (newQuantity < 1) {
          el.value = 1;
          newQuantity = 1;
        }

        if (newQuantity > maxQuantity) {
          newQuantity = maxQuantity;
          el.value = newQuantity;

          Alpine.store('notification').notify({
            type: 'info',
            title: 'Notify',
            message: 'The product has reached the maximum quantity limit.',
          });
        }

        this.update(productId, newQuantity);
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('filter', () => ({
      loading: false,
      searchParams: new URLSearchParams(window.location.search),
      filterData: [],

      init() {
        window.addEventListener('popstate', this.onHistoryChange);
      },

      updateFilters() {
        let url = `${window.location.pathname}?${this.searchParams.toString()}`;
        this.renderPage(url);
        history.pushState({ searchParams: this.searchParams.toString() }, '', url);
      },

      renderPage(url) {
        this.loading = true;
        fetch(url)
          .then((res) => res.text())
          .then((html) => {
            let doc = new DOMParser().parseFromString(html, 'text/html');
            this.updateDOM('#ProductGridContainer', doc);
            this.updateDOM('#ProductCount', doc);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      updateDOM(selector, doc) {
        let newContent = doc.querySelector(selector);
        if (newContent) document.querySelector(selector).innerHTML = newContent.innerHTML;
      },

      onHistoryChange(event) {
        if (event.state) {
          this.searchParams = new URLSearchParams(event.state.searchParams);
          this.updateFilters();
        }
      },

      onFilterChange(event) {
        let form = event.target.closest('form');
        this.searchParams = new URLSearchParams(new FormData(form));
        this.updateFilters();
      },

      onSortChange(event) {
        let sortValue = event.target.value;

        if (sortValue) {
          this.searchParams.set('sort_by', sortValue);
        } else {
          this.searchParams.delete('sort_by');
        }

        this.updateFilters();
      },

      removeFilter(event) {
        event.preventDefault();
        let param = new URL(event.currentTarget.href).searchParams;
        param.forEach((_, key) => this.searchParams.delete(key));
        this.updateFilters();
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
